import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Select wallet address',
  selectCaption: 'Select HD derivation path',
  addressesCaption: 'Select the address you would like to use',

  selectButtonText: 'select',
});
